module.exports = __webpack_public_path__ + "static/media/english.e994973c.jpg";